import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import { envAwarePost } from "../../util/util";

const currencyAdapter = createEntityAdapter()

export const updatePresentmentCurrency = createAsyncThunk(
  'appSettings/updatePresentmentCurrency',
  async currency_id => await envAwarePost(
    'api/settings/api/',
    {
      action:'updatePresentmentCurrency', 
      currency_id
    }
  )
)


export const getDataPermissions = createAsyncThunk(
  "getDataPermissions",
  async () => envAwarePost("api/user/api.php",{
    action: "getDataPermissions"
  })
);

export const toggleSharedClientRestrictions = createAsyncThunk(
  'settings/toggleSharedClientRestrictions',
  async ()=> await envAwarePost('api/settings/api/',{
    action:'toggleSharedClientRestrictions'
  })
)

export const updateDataPermissions = createAsyncThunk(
  "updateDataPermissions",
  async payload => envAwarePost("api/user/",{
    action: "updateDataPermissions",
    ...payload
  })
);

export const getAllWelcomeLinks = createAsyncThunk(
  'settings/getAllWelcomeLinks',
  async ()=> await envAwarePost('api/settings/',{action:'getAllWelcomeLinks'})
)

export const toggleWelcomeLinks = createAsyncThunk(
  'settings/toggleWelcomeLinks',
  async payload => await envAwarePost('api/settings/',{
    action:'toggleWelcomeLinks',
    ...payload
  })
)

export const updateAppSettings = createAsyncThunk(
  'settings/updateAppSettings',
  async update => await envAwarePost('api/settings/',{
    action:'updateAppSettings',
    update
  })
)

export const updateWelcomeLinks = createAsyncThunk(
  'settings/updateWelcomeLinks',
  async payload => {
      //map device string to id value
      const device = {'web':0,'iOS':1,'android':2,all:'all'}[payload.device]
      const {account_type,link} = payload
      return await envAwarePost('api/help/',{
        action:'updateWelcomeLinks',
        account_type,
        device,
        link
    })
  }
)

export const cancelAccount = createAsyncThunk(
  "cancelAccount",
  async (payload) => (envAwarePost("api/cancelAccount",
      {...payload, action: "cancelAccount"}
  ))
)

const extractAccountTypeLinks = (links,accountType) => {
  const accountLinks = {}
  Object.entries(links).map(([k,v])=>{
    accountLinks[k] = v[accountType]
  })
  return accountLinks
}

const slice = createSlice({
  name: "settings",
  initialState: {
    //settings related to app features like
    //hiding the fitsw.ai button
    app:{
      enable_fitswai:0,
      hide_default_foods:0
    },
    acceptedCurrencyId: null,
    acceptedCurrencies:currencyAdapter.getInitialState(),
    dataPermissions: [],
    dataPermissionsStatus: "idle",
    welcomeLinks:{
      status:'init',
      client:{},
      trainer:{}
    }
  },
  reducers: {
    setAcceptedCurrencyId: (state, action) => {
      state.acceptedCurrencyId = action.payload
    },
    setAcceptedCurrencies: (state, action) => {
      currencyAdapter.upsertMany(state.acceptedCurrencies,action.payload)
    },
    setGymResourceSettings:(state,action)=>{
      state.gymResourceSettings = action.payload
    },
    setAppSettings: (state,action)=>{
      state.app = action.payload
    }
  },
  extraReducers: {
    [getAllWelcomeLinks.pending] : (state) => {
      state.welcomeLinks.status = 'pending'
    },
    [toggleSharedClientRestrictions.pending] : (state)=>{
      state.gymResourceSettings.shared_client_restrictions ^= 1
    },  
    [updateWelcomeLinks.pending] : (state,action) => {
      const {link,account_type,device} = action.meta.arg
      if(device !== 'all'){
        state.welcomeLinks[account_type][device].welcome_link = link
      }else{
        ['web','iOS','android'].forEach(d=>{
          state.welcomeLinks[account_type][d].welcome_link = link
        })
      }
    },
    [getAllWelcomeLinks.fulfilled] : (state, action)=>{
      const {success,data:{links}} = action.payload
      state.welcomeLinks.client = extractAccountTypeLinks(links,'client')
      state.welcomeLinks.trainer = extractAccountTypeLinks(links,'trainer')
      state.welcomeLinks.status = 'idle'
    },
    [toggleWelcomeLinks.pending] : (state,action)=>{
      const {enabled,account_type} = action.meta.arg
      Object.values(state.welcomeLinks[account_type]).forEach(device=>{
        device.enabled = enabled
      })
    },
    [getDataPermissions.fulfilled]: (state, action) => {
      const { success, data } = action.payload;
      if (success == 1) {
        state.dataPermissions = data;
        state.dataPermissionsStatus = "idle";
      }
    },
    [updateDataPermissions.fulfilled]: (state, action) => {
      const { success, data } = action.payload;
      if (success == 1) {
        state.dataPermissions[Object.keys(action.meta.arg)[0]].value = Object.values(action.meta.arg)[0];
       
      }
    },
    [updatePresentmentCurrency.pending] : (state,action)=>{
      state.acceptedCurrencyId = action.meta.arg
    },
    [updateAppSettings.pending] : (state,action)=>{
      const update = action.meta.arg
      state.app = {
        ...state.app,
        ...update
      }
    }
  },
});


export const { setAcceptedCurrencyId, setAcceptedCurrencies, setGymResourceSettings, setAppSettings} = slice.actions


export const {
  selectAll: selectAllCurrencies,
  selectById: selectCurrencyById,
  selectIds: selectCurrencyIds
} = currencyAdapter.getSelectors(state => state.settings.acceptedCurrencies)

export const selectAcceptedCurrency = state => (
  selectCurrencyById(state,state.settings.acceptedCurrencyId)
)

export default slice.reducer;
